<template>
  <header id="header">
    <router-link to="/">
      Mark
      <span>.</span>
      Bloomfield
    </router-link>

    <div>A blog about code</div>
  </header>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style scoped>
#header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 50px;
  background: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 5%;
  padding-right: 5%;
}

a,
div {
  margin: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 55%;
  letter-spacing: 2px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  text-decoration: none;
  font-family: "Nunito";
}

a > span {
  color: yellow;
  font-weight: bold;
}

div {
  color: rgba(255, 255, 255, 0.5);
}
</style>
